function killSession(): void {
    window.localStorage.clear();
}

export const BrowserStorageHelper = {
    killSession,
};
